module.exports = __webpack_public_path__ + "static/media/chicargos-product-detail.37ce5c2e.jpg";